<section class="content" *ngIf="!enable_old_gatepass_page">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Ordered From Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Ordered To Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="to_date" [min]="from_date" />
      </div>
      <div class="col-2" style="margin-top: 3%;">
        <button mat-raised-button color="primary" (click)="serveOldGatePassAndOrder()" class="button-class"
          style="font-size: 20px;" [disabled]="from_date == null || to_date == null">Search</button>
        <mat-spinner [diameter]="40" *ngIf="data_loading"></mat-spinner>
      </div>
      <div class="col-2" *ngIf="is_data_available" style="margin-top: 1%;">
        <button mat-button class="button-class" (click)="enableMainAndSubPage()" style="margin-top:25px"><i
            class="material-icons">
            picture_as_pdf
          </i> Old GatePass List</button>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="sale_data.length !== 0" style="padding: 25px; background: #d1ceca;
  ">
    <form [formGroup]="vehicle_register_form">
      <div class="row">
        <div class="col-3">
          <mat-label>Driver Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
          <input type="text" formControlName="driver_name" class="main-border-class" />
        </div>
        <div class="col-3">
          <mat-label>Vehicle Number <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
          <input type="text" formControlName="vehicle_number" class="main-border-class" />
        </div>
        <div class="col-3">
          <mat-label>Vehicle Start Time <i class="material-icons" style="color: red;font-size: 14px;">star</i>
          </mat-label>
          <input type="time" formControlName="vehicle_start_time" class="main-border-class" />
          <br><i>You should enter greater than one minute from current time</i>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col" style="font-size: 16px; font-weight: bold;">
        Select order to take gatepass
      </div>
    </div>
    <div style="padding: 25px; border: 1px solid; margin-top: 2%; margin-bottom: 2%;">
      <div class="row">
        <div class="col-3" *ngFor="let sale of sale_data; let sale_index=index">
          <mat-checkbox [(ngModel)]="sale['is_selected']" [checked]="sale['is_selected']">{{ sale['business_code'] }} -
            <span style="font-weight: bold;">{{ sale['bill_number']}}</span>
            - {{ sale['ordered_date'] | date }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="col" style="text-align: center;">
      <button mat-raised-button color="primary" (click)="generateClicked()" class="button-class"
        *ngIf="!is_gate_pass_prepared" style="font-size: 20px;"
        [disabled]="!vehicle_register_form.valid">Generate</button>
    </div>
  </div>
  <div class="row" *ngIf="is_gate_pass_prepared" style="text-align: center;">
    <div class="col">
      <button mat-raised-button color="primary" (click)="downloadClicked()" class="button-class"
        style="font-size: 20px;">Download Prepared Gatepass</button>
    </div>
  </div>

</section>
<section class="content" *ngIf="enable_old_gatepass_page">
  <div class="row">
    <div class="col-sm-2 col-lg-2" (click)="enableMainAndSubPage()">
      <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;">arrow_back</i>
    </div>
    <div class="col-sm-6 col-lg-6">
      <p class="text-center" style="font-size: 30px;">Old Vehicle Gatepass List</p>
    </div>
    <div class="col-sm-4 col-lg-4"></div>
  </div>
  <div class="card" style="padding: 18px;">
    <table class="table table-bordered table-hovered">
      <thead>
        <tr>
          <th>S. No</th>
          <th>Date</th>
          <th>Driver Name</th>
          <th>Vehicle Number</th>
          <th></th>
        </tr>
      </thead>
      <tbody *ngFor="let gate_pass of old_gate_pass_list; let gate_pass_index=index">
        <tr>
          <td>{{gate_pass_index + 1}}</td>
          <td>{{gate_pass['order_from'] | date }} - {{gate_pass['order_to'] | date }}</td>
          <td>{{gate_pass['driver_name']}}</td>
          <td>{{gate_pass['vehicle_number']}}</td>
          <td><button mat-raised-button color="primary"
              (click)="downloadOldGatepassClicked(gate_pass['file_in_base_64'], gate_pass['vehicle_number'], gate_pass['driver_name'])"
              class="button-class" style="font-size: 20px;">Download</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
